const isEmptyValue = (value) => {
	return !value || value.trim() === ''
}

const createError = (element, message) => {
	return {
		element,
		message,
	}
}

const renderError = (error) => {
	const { element, message } = error
	const errorElement = document.createElement('p')
	errorElement.classList.add('field-error')
	errorElement.textContent = message
	element.parentElement.parentElement.appendChild(errorElement)
}

const clearErrors = () => {
	const errors = document.querySelectorAll('.field-error')
	errors.forEach((error) => error.remove())
}

const clearError = (element) => {
	const error =
		element.parentElement.parentElement.querySelector('.field-error')
	if (error) error.remove()
}

const setupCartInfoForm = () => {
	const cartForm = document.getElementById('cart')

	if (!cartForm) {
		console.error('No cart form found')
		return
	}

	const cartInfoSection = document.getElementById('main-cart-info')
	if (!cartInfoSection) {
		console.error('No cart info section found')
		return
	}
	const cartInfoForm = cartInfoSection.querySelector('form')

	if (!cartInfoForm) {
		console.error('No cart info form found')
		return
	}

	const fields = {
		vat_number: document.getElementById('vat-number'),
		contact_person: document.getElementById('contact-person'),
		invoice_reference: document.getElementById('invoice-reference'),
		extra_info: document.getElementById('extra-info'),
		ean_number: document.getElementById('ean-number'),
		salesplace: document.getElementById('salesplace'),
	}

	Object.values(fields).forEach((field) => {
		field.addEventListener('input', () => {
			clearError(field)
		})
	})

	const validateForm = () => {
		const errors = []
		if (isEmptyValue(fields.vat_number.value))
			errors.push(
				createError(fields.vat_number, 'This field is required')
			)
		if (isEmptyValue(fields.contact_person.value))
			errors.push(
				createError(fields.contact_person, 'This field is required')
			)
		if (isEmptyValue(fields.salesplace.value)) {
			errors.push(
				createError(fields.salesplace, 'This field is required')
			)
		}
		return errors
	}

	const addInfoToOrder = async () => {
		const attributes = {
			[fields.vat_number.getAttribute('name')]: fields.vat_number.value,
			[fields.contact_person.getAttribute('name')]:
				fields.contact_person.value,
			[fields.invoice_reference.getAttribute('name')]:
				fields.invoice_reference.value,
			[fields.extra_info.getAttribute('name')]: fields.extra_info.value,
			[fields.salesplace.getAttribute('name')]: fields.salesplace.value,
		}

		console.info('Adding info to order', attributes)

		const response = await fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ attributes }),
		})

		return response.json()
	}

	const handleCheckout = async () => {
		clearErrors()
		const errors = validateForm()

		if (errors.length > 0) {
			errors.forEach((error) => {
				renderError(error)
			})
			return
		}

		try {
			await addInfoToOrder()
			window.location.href = '/checkout'
		} catch (error) {
			alert('An error occurred while adding info to order', error)
		}
	}

	cartForm.addEventListener('submit', (event) => {
		event.preventDefault()
		handleCheckout(event)
	})
}

setupCartInfoForm()
